<template>
    <div class="main">
        <!--Filter-->
        <v-container fluid class="pa-0">
            <v-card class="d-flex ml-2 pt-2 pb-0 flex-row" outlined>
                <v-form class="slim">
                    <v-container class="d-flex ml-2 pt-2 flex-row flex-wrap">

                        <v-autocomplete class="pr-2 mx-240" v-model="filter.fkNInstalacion" :items="instalations" item-text="fldTNombre" item-value="idNInstalacion" label="Instalacion" outlined clearable dense></v-autocomplete>                        

                        <v-card-actions class="btns-float">
                            <v-btn color="grey" small @click="clearFilter">Limpiar</v-btn>

                            <v-btn color="accent" dark small @click="loadData">Filtrar</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>
            </v-card>
        </v-container>

        <!--Buttons-->
        <v-container class="pb-3 ml-1 mb-3">
            <v-btn color="accent" small dark @click="addItem">Agregar Relacion</v-btn>
        </v-container>

        <!--NuevoForm-->
        <v-dialog persistent v-model="nuevoForm" max-width="510">
            <v-card class="mx-auto">
                <v-toolbar color="blue" dark>
                    <v-toolbar-title>Agregar Relacion</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-form ref="formularioNuevo" class="slim">
                    <v-container class="d-flex pt-6 flex-row flex-wrap">
                        <v-autocomplete class="pr-3 mx-240" v-model="item.fkNInstalacion" :items="instalations" item-text="fldTNombre" item-value="idNInstalacion" label="Instalacion" outlined :rules="instalationRules" dense></v-autocomplete>
                        <v-autocomplete class="pr-3 mx-240" v-model="item.fkNUsuario" :items="users" item-text="fldTNombre" item-value="idNUsuario" label="Usuario" outlined :rules="userRules" dense></v-autocomplete>
                        <v-card-actions class="btns-float px-6 pb-6">
                            <v-btn text small @click="nuevoForm = false">
                                cancelar
                            </v-btn>
                            <v-btn color="blue" dark small @click="saveData">
                                Guardar cambios
                            </v-btn>
                        </v-card-actions>
                    </v-container>
                </v-form>

            </v-card>
        </v-dialog>

        <!--EditForm-->
        <template>
            <v-row justify="center">
                <v-dialog persistent v-model="editForm" max-width="520">
                    <v-card class="mx-auto">
                        <v-toolbar color="blue" dark>
                            <v-toolbar-title>Editar Relacion</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-form ref="formularioEdicion" class="slim">
                            <v-container class="d-flex pt-6 flex-row flex-wrap ">                                

                                <v-autocomplete class="pr-2 mx-240" v-model="item.fkNInstalacion" :items="instalations" item-text="fldTNombre" item-value="idNInstalacion" :disabled="puedeCambiar == false" label="Instalacion" outlined :rules="instalationRules" dense></v-autocomplete>
                                <v-autocomplete class="pr-2 mx-240" v-model="item.fkNUsuario" :items="users" item-text="fldTNombre" item-value="idNUsuario" :disabled="puedeCambiar == false" label="Usuario" outlined :rules="userRules" dense></v-autocomplete>

                                <v-card-actions class="justify-space-between w-100 pb-6">
                                    <v-btn class="ma-2" dark small color="red" @click="deleteItem">
                                        <v-icon left>mdi-delete</v-icon> Borrar registro
                                    </v-btn>
                                    <div class="justify-right">
                                        <v-btn class="ma-2" small color="blue lighten-5" @click="chkBotonCancelar">
                                            Cancelar
                                        </v-btn>
                                        <v-btn v-if="puedeCambiar == false" class="ma-2" dark small color="success" @click="puedeCambiar = true">
                                            <v-icon left>mdi-pencil</v-icon> Editar
                                        </v-btn>
                                        <v-btn v-else class="ma-2" dark small color="success" @click="saveData">
                                            <v-icon left>mdi-pencil</v-icon> Guardar
                                        </v-btn>
                                    </div>
                                </v-card-actions>
                            </v-container>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <v-container fluid class="py-0">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-card>
                        <v-data-table dense :headers="headers" :items="items" item-key="idNRelacionInstalacionUsuario" :items-per-page="5" :footer-props="{'items-per-page-options': [5, 10, 20, 50]}" class="elevation-1 gt slim">
                            <template v-slot:item.ico1="{ item }">
                                <v-chip :color="item.ico1" dark label></v-chip>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon color="green" @click="editItem(item)" class="ml-3">
                                    mdi-pencil
                                </v-icon>
                            </template>
                            <template v-slot:item.fkNInstalacion="{ item }">
                                {{getInstalationDescription(item.fkNInstalacion)}}
                            </template>
                            <template v-slot:item.fkNUsuario="{ item }">
                                {{getUserDescription(item.fkNUsuario)}}
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>        

        <confirm ref="confirmDialog">
        </confirm>
    </div>
</template>

<script>
import {
    Component,
    Prop,
    Vue
} from "vue-property-decorator";
    import InstalationUserRelationshipService from "../services/InstalationUserRelationshipService";
    import InstalationsService from "../services/InstalationsService";
    import UserService from "../services/UserService";
    import InstalationUserRelationshipModel from "../models/InstalationUserRelationshipModel";
    import Confirm from '../components/ConfirmDelete';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';

@Component({
    components: {
        Confirm
    },
    mounted: async function () {        
        await this.loadData();
    },
    computed: {
        },
    methods: {
        chkBotonCancelar() {
                // Estoy editando y presiono cancelar
                if (this.$data.puedeCambiar == true && this.$data.editForm == true) {
                    this.$data.item = JSON.parse(JSON.stringify(this.$data.itemAux));
                    this.$data.puedeCambiar = false;
                } else {
                    this.closeDialog();
                }
            },
        loadData: async function () {
            try {
                var a = await new InstalationUserRelationshipService().getByUser(this.$route.params.id);
                if (a.success == false) {
                    this.showError(a.error);
                    return;
                }
                this.$data.items = a.data;

                var resultUsr = await new UserService().list({});
                if (resultUsr.success) {
                    this.$data.users = resultUsr.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultUsr.Message);
                }  

                var resultInst = await new InstalationsService().list({});
                if (resultInst.success) {
                    this.$data.instalations = resultInst.data;
                }
                else {
                    this.showError('Ocurrio un error: ' + resultInst.Message);
                }

            } catch (e) {
                console.log(e);
            }
        },
                
        clearFilter: function () {
            this.filter = new InstalationUserRelationshipModel();
            //Reseteamos los contadores usados para manejar el indeterminado
            this.loadData();
        },
        addItem: function () {
            this.$data.item = new InstalationUserRelationshipModel();            
            this.$data.nuevoForm = true;
        },
        saveData: async function () {
            try {
                if (this.$refs.formularioNuevo != null) {
                     if (!this.$refs.formularioNuevo.validate()) {
                        return;
                     }
                 }

                 if (this.$refs.formularioEdicion != null) {
                     if (!this.$refs.formularioEdicion.validate()) {
                        return;
                     }
                 }

                var uService = new InstalationUserRelationshipService();
                var data = null;
                if (this.$data.item.IdNRelacionInstalacionUsuario) {                    
                    data = await uService.update(this.$data.item);
                } else {                    
                    data = await uService.insert(this.$data.item);
                }
                if (data.success) {
                        this.nuevoForm = false;
                        this.closeDialog();
                        this.loadData();
                        this.showSuccess('El registro fue guardado correctamente');
                    } else {
                        this.showError('Ocurrio un error al guardar el registro: ' + data.error);
                    }
            } catch (e) {
                console.log(e);
            }
        },
        getUserDescription(id) {
            let desc = this.users.find(function (e) {
                return e.idNUsuario == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        },
        getInstalationDescription(id) {
            let desc = this.instalations.find(function (e) {
                return e.idNInstalacion == id;
            });
            if (desc)
                return desc.fldTNombre;
            return id;
        },
        closeDialog() {
            this.editForm = false;
            this.puedeCambiar = false;
            this.alert = false;
            this.$data.item = new InstalationUserRelationshipModel();
            this.$data.itemAux = new InstalationUserRelationshipModel();
        },
        editItem(item) {
            this.$data.item = JSON.parse(JSON.stringify(item));
            this.$data.itemAux = JSON.parse(JSON.stringify(item));
            this.$data.editForm = true;
        },
        async deleteItem() {
             var ret = await this.$refs.confirmDialog.showDialog();
                if (ret == true) {
                    var data = await new InstalationUserRelationshipService().delete(this.$data.item);
                    if (data.success) {
                        this.closeDialog();
                        this.showSuccess('El registro fue eliminado correctamente');
                        this.loadData();
                    } else {
                        this.showError('Ocurrio un error borrando el registro: ' + data.error);
                    }
                 }
        },
        async exportExcel() {
            var data = await new InstalationUserRelationshipService().export(this.filter);
            var fileURL = window.URL.createObjectURL(data);
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'RelacionesInstalacionesUsuarios.xlsx');
            document.body.appendChild(fileLink);

            fileLink.click();
        },
        exportPDF() {
                var doc = new jsPDF({ orientation: 'landscape' });
                var title = 'RelacionesInstalacionesUsuarios';
                var columns = [
                    { title: 'Usuario', dataKey: 'fkNUsuario' },
                    { title: 'Instalacion', dataKey: 'fkNInstalacion' },
                ];
                // Customizar columnas
            doc.text(title, 15, 15);
            var self = this;
                var data = JSON.parse(JSON.stringify(this.$data.items));
                    data.forEach(function (d) {
                        d.fkNInstalacion = self.getInstalationDescription(d.fkNInstalacion);
                        d.fkNUsuario = self.getUserDescription(d.fkNUsuario);
                    });
                doc.autoTable(columns, data, { margin: { top: 20 } })
                doc.save(title + '.pdf');
            }
    },
})
export default class RelacionesInstalacionesUsuarios extends Vue {
    
    nuevoForm = false;
    editForm = false;
    puedeCambiar = false;
    formularioNuevo = true;
    formularioEdicion = true;
    alert = false;

    // Modelos
    item = new InstalationUserRelationshipModel();
    itemAux = new InstalationUserRelationshipModel();
    filter = new InstalationUserRelationshipModel();
    

    // Listas
    items = [];
    users = [];
    instalations = [];

    
    headers = [{
                text: '',
                value: 'ico1',
                sortable: false,
                width: 10
        },{
            text: '',
            value: 'action',
            sortable: false
        },        
        {
            text: 'Instalacion',
            value: 'fkNInstalacion'
        },
        {
            text: 'Usuario',
            value: 'fkNUsuario'
        },
    ];
    userRules = [
        v => !!v || 'Debe seleccionar un Usuario',
    ];
    instalationRules = [
        v => !!v || 'Debe seleccionar una Instalacion',
    ];
}
</script>
